<label
  *ngIf="labelText"
  [htmlFor]="id"
  [ngClass]="isDisabled ? 'eq-form-label-top--disabled' : ''"
>
  {{ labelText }}
</label>
<!-- <span *ngIf="isRequired">*</span> -->
<div class="eq-input-group">
  <input
    #textInput
    type="text"
    [id]="id"
    [name]="name"
    [placeholder]="placeholder"
    [required]="isRequired && error"
    [disabled]="isDisabled"
    [value]="value"
    (blur)="onBlur()"
    (input)="onValueChange($event.target.value)"
    class="eq-form-input {{inputClass}}"
    [ngClass]="error ? 'invalid' : ''"
  />
  <small *ngIf="error" class="eq-text-sm eq-mt-2 eq-text-red-brandRed-hover">
    {{ errorText }}
  </small>
</div>
